let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bbrSy")).then(() => parcelRequire('kGAqz'));